// extracted by mini-css-extract-plugin
export default {"back":"SnakeGame_back__zwd8B","map":"SnakeGame_map__LHzUF","snake":"SnakeGame_snake__prWU-","berry":"SnakeGame_berry__T-jmE"};